// @flow
import axios from "axios";
import config, { socket_endpoint } from "../config";
import { FEATURE_CUSTOM_PAYMENT } from "../constant";
import { setLoginModal, setUserIsLogin } from "../redux/tool-webjam/actions";
import { setPaymentInvitationCount, setTimezones, setUserPackageSubscription, setWillShowDashboard } from "./components/payment/payment-reducer/actions";
import { subscriptionObj } from "./components/payment/Utils";
import { authToken, apiVersion } from "./Utils";
import { dynamicMessageLocale, expiredSubscription } from "../constant-Utils";

const base_url = config.socket_endpoint + apiVersion;
const paymentBase = config.socket_endpoint;

const apiPaymentVersion = "/api/v1";

declare var APP: Object;

const handleUserUnAuth = (error) => {

    console.log("API error ", error)
    if (error?.response?.status == 403 || error?.response?.status == 401) {
        if (APP != undefined) {
            localStorage.removeItem("auth")
            APP.store.dispatch(setUserIsLogin(false))
            APP.store.dispatch(setLoginModal(true))
        }
    }
}

export const getPackageList = () => {
    return axios({
        method: 'get',
        url: paymentBase + apiPaymentVersion + "/payment/get-subscription-package",
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)
        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const buyPackage = (data) => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/buy-subscription-package",
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const fetchMyInvitation = (data, pagination = '') => {
    return axios({
        method: 'get',
        // url: paymentBase + apiPaymentVersion + "/payment/get-room/invited" + pagination,
        url: paymentBase + "/get-other-rooms" + pagination,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const updateInviation = (data) => {
    return axios({
        method: 'PUT',
        url: paymentBase + apiPaymentVersion + "/payment/update-room-invite/" + data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const getMyContacts = (data, pagination = '') => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/get-contact-list" + pagination,
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const createContact = (data) => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/create-contact",
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}
export const updateContact = (data) => {
    return axios({
        method: 'PUT',
        url: paymentBase + apiPaymentVersion + "/payment/update-contact/" + data.id,
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const deleteContact = (data) => {
    return axios({
        method: 'DELETE',
        url: paymentBase + apiPaymentVersion + "/payment/delete-contact/" + data.id,
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}
export const deleteGroup = (data) => {
    return axios({
        method: 'DELETE',
        url: paymentBase + apiPaymentVersion + "/payment/delete-contact-group/" + data.id,
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const getMyContactGroup = (data, pagination = '') => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/get-contact-group" + pagination,
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const createContactGroup = (data) => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/create-contact-group",
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const updateContactGroup = (data) => {
    return axios({
        method: 'PUT',
        url: paymentBase + apiPaymentVersion + "/payment/update-contact-group/" + data.id,
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const getRoomList = (data, page = 'hosted', pagination = '') => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/get-room/" + page + "/" + pagination,
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}


export const createRoom = (data) => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/create-room",
        data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const updateRoom = (data, id) => {
    return axios({
        method: 'PUT',
        url: paymentBase + apiPaymentVersion + "/payment/update-room/" + id, // temporary commented, will use this url later when BE code updated
        // url: paymentBase+"/v3/update_owner_Room",  // will remove this url once above api url get updated from BE for paid room
        data: data,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const deleteRoom = (data) => {
    return axios({
        method: 'DELETE',
        url: paymentBase + apiPaymentVersion + "/payment/delete-room/" + data.id,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)
        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const getMySubscription = (data, flag = null) => {

    // console.log("user subsc flag ",flag,"tokwn ",authToken())
    return (dispatch, getState) => {
        return axios({
            method: 'GET',
            url: paymentBase + apiPaymentVersion + "/payment/get-user-subscription",
            headers: authToken()
        }).then(async (res) => {
            if (res.data.status) {
                let data = res.data.data;
                let storeData = {
                    end_at: data.end_at,
                    is_canceled: data.is_canceled,
                    name: data.name,
                    amount: data.amount,
                    status: data.status,
                    subscription_id: data.subscription_id,
                    trial_started: data.trial_started,
                    trial_ended: data.trial_ended,
                    start_at: data.start_at,
                    canceled_at: data.canceled_at,
                    _id: data._id,
                    pack_id: data.pack_id,
                    package_type: data.package_type,
                    is_premium: data.is_premium || false,
                    is_expired: false,
                    coupon_code_id: data?.coupon_code_id || null,
                    is_refunded: data?.is_refunded || false,
                    refunded_at: data?.refunded_at || 0,
                    due_data: data?.due_data || {
                        created: 0,
                        failure_message: "",
                        paid: false,
                        pay_url: "",
                        period: {
                            end: 0,
                            start: 0
                        },
                        status: ""
                    },
                    isActive: true
                }

                if (storeData.due_data.failure_message) {
                    storeData.due_data.failure_message = await dynamicMessageLocale(storeData.due_data.failure_message)
                }

                if (window.location.origin.indexOf("local") != -1 || window.location.origin.indexOf("192.168") != -1) {
                    if (!storeData.is_premium) {
                        if (storeData.name.toLowerCase().indexOf("premium") != -1) {
                            storeData.is_premium = true
                        }
                    }
                }

                if (storeData.name) {
                    if (storeData.trial_ended && storeData.trial_started) {
                        if ((storeData.trial_ended < Math.round(new Date().getTime() / 1000) && storeData.end_at < Math.round(new Date().getTime() / 1000)) || storeData.end_at < Math.round(new Date().getTime() / 1000)) {
                            storeData.is_expired = true;
                            storeData.isActive = false;
                        }

                        if (storeData.trial_ended < Math.round(new Date().getTime() / 1000) && storeData.end_at > Math.round(new Date().getTime() / 1000)) {
                            storeData.trial_ended = null; // if trail date less than current date, then set trail_ended = null
                        }
                    } else if (storeData.end_at < Math.round(new Date().getTime() / 1000)) {
                        storeData.isActive = false
                    }
                }



                if (storeData.name) {
                    // non allowed status
                    if (expiredSubscription.indexOf(storeData.status) != -1) {
                        storeData.is_expired = true;
                        storeData.isActive = false;
                    }
                }

                dispatch(setUserPackageSubscription(storeData))
                return {
                    status: 1,
                    data: res.data
                }
            } else {
                if (data && !data.hasOwnProperty("emptyPack")) {
                    dispatch(setUserPackageSubscription(subscriptionObj))
                }
                return {
                    status: 0,
                    data: res.data
                }
            }
        }).catch((error) => {
            if (data && !data.hasOwnProperty("emptyPack")) {
                dispatch(setUserPackageSubscription(subscriptionObj))
            }
            // handleUserUnAuth(error)
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data
                }
            }
        })
    }
}


export const cancelMySubscription = (data) => {
    return axios({
        method: 'DELETE',
        url: paymentBase + apiPaymentVersion + "/payment/cancel-subscription-package",
        headers: authToken(),
        data
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                message: res.data.message
            }
        }

        return {
            status: 0,
            message: res.data.message
        }
    }).catch((error) => {
        handleUserUnAuth(error)
        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data,
                message: error?.response?.data?.message,
            }
        }
    })
}


export const getTimezone = (data) => {
    return (dispatch) => {
        return axios({
            method: 'GET',
            url: paymentBase + apiPaymentVersion + "/payment/get-timezone",
            headers: authToken(),
            data
        }).then((res) => {
            if (res.data.status) {
                dispatch(setTimezones(res.data.data || []))
            }
        }).catch((error) => {
            handleUserUnAuth(error)
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data,
                    message: error?.response?.data?.message,
                }
            }
        })
    }
}
export const getPendingInvitations = (data) => {
    return (dispatch) => {
        return axios({
            method: 'POST',
            url: paymentBase + apiPaymentVersion + "/payment/get-pending-invitation",
            headers: authToken(),
            data
        }).then((res) => {
            if (res.data.status) {
                dispatch(setPaymentInvitationCount(res.data.invitation || 0))
            }
        }).catch((error) => {
            handleUserUnAuth(error)
            if (error.response) {
                return {
                    status: 0,
                    error: error.response.status,
                    data: error?.response?.data,
                    message: error?.response?.data?.message,
                }
            }
        })
    }
}

export const getSubscriptionPaymentHistory = (pagination) => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/payment-history-v2/subscription" + pagination + `${pagination ? "&isPagination=true" : "?isPagination=true"}`,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const getPaidRoomPaymentHistory = (pagination) => {
    return axios({
        method: 'POST',
        url: paymentBase + apiPaymentVersion + "/payment/payment-history/room-payment" + pagination,
        headers: authToken()
    }).then((res) => {
        if (res.data.status) {
            return {
                status: 1,
                data: res.data
            }
        }
        return {
            status: 0,
            data: res.data
        }
    }).catch((error) => {
        handleUserUnAuth(error)

        if (error.response) {
            return {
                status: 0,
                error: error.response.status,
                data: error?.response?.data
            }
        }
    })
}

export const applyCouponCode = (data) => {
    return axios({
        method: 'POST',
        url: `${paymentBase}/common/subscription-coupon-code`,
        headers: authToken(),
        data
    }).then((res) => {
        return {
            status: 1,
            data: res.data
        }
    }).catch((error) => {
        return {
            status: 0,
            error: error.response.status,
            data: error?.response?.data
        }
    })
}